// Identity of the build this browser is running — stamped automatically.
//
// The deploy workflow (.github/workflows/azure-static-web-apps.yml) sets
// REACT_APP_BUILD_SHA (the git commit) and REACT_APP_BUILD_TIME (UTC ISO)
// at build time, and publishes the same identity as /version.json next to
// the bundle. Nothing here is edited by hand: these constants used to be,
// and the login page said "25 August 2026 · Pending deploy · v2.06" for two
// months of releases after someone stopped bumping them (2026-10-28).
//
// The curated changelog (Revision History, Guides) is separate and keeps
// its own version numbers; this file only says which build is running.
//
// A local `yarn start` has no stamp and says so ("Local development build").

const SHA = (process.env.REACT_APP_BUILD_SHA || "").trim();
const BUILT_AT = (process.env.REACT_APP_BUILD_TIME || "").trim();
// Eyvo is in California; the old hand-written stamps were Pacific time too.
const TZ = "America/Los_Angeles";

function _fmt(locale, opts) {
  if (!BUILT_AT) return "";
  const d = new Date(BUILT_AT);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return d.toLocaleString(locale, { timeZone: TZ, ...opts });
  } catch {
    return d.toISOString();
  }
}

export const APP_BUILD_SHA = SHA;                      // full commit, "" locally
export const APP_BUILD_TIME = BUILT_AT || null;        // UTC ISO, null locally
export const IS_STAMPED_BUILD = Boolean(SHA && BUILT_AT);

// Short build id — what people read, compare and quote ("build fc235ea").
export const APP_VERSION = SHA ? SHA.slice(0, 7) : "dev";
// "28 October 2026"
export const APP_RELEASE_DATE = _fmt("en-GB", { day: "numeric", month: "long", year: "numeric" })
  || "Local development build";
// "10:42 AM PDT"
export const APP_DEPLOYED_AT = _fmt("en-US", { hour: "numeric", minute: "2-digit", timeZoneName: "short" })
  || "not deployed";

// Footer / login card: "Release: 28 October 2026 · 10:42 AM PDT · build fc235ea"
export const LATEST_RELEASE_LABEL = IS_STAMPED_BUILD
  ? `Release: ${APP_RELEASE_DATE} · ${APP_DEPLOYED_AT} · build ${APP_VERSION}`
  : "Local development build";

// Guide / Testing Plan covers: "Build fc235ea · 28 October 2026 · Deployed 10:42 AM PDT"
export const RELEASE_STAMP_LONG = IS_STAMPED_BUILD
  ? `Build ${APP_VERSION} · ${APP_RELEASE_DATE} · Deployed ${APP_DEPLOYED_AT}`
  : "Local development build";

// "28 October 2026 · Build fc235ea · Deployed 10:42 AM PDT"
export const RELEASE_STAMP_SHORT = IS_STAMPED_BUILD
  ? `${APP_RELEASE_DATE} · Build ${APP_VERSION} · Deployed ${APP_DEPLOYED_AT}`
  : "Local development build";
